import { render, staticRenderFns } from "./SimulatorExchange.vue?vue&type=template&id=511b0132&scoped=true"
import script from "./SimulatorExchange.vue?vue&type=script&lang=js"
export * from "./SimulatorExchange.vue?vue&type=script&lang=js"
import style0 from "./SimulatorExchange.vue?vue&type=style&index=0&id=511b0132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b0132",
  null
  
)

export default component.exports